import { requireAuthOrProspectEmail } from '../guards';

export const path = '/optional-bet/:orderId';
export const component = 'OptionalBet';
export const thunk = () => requireAuthOrProspectEmail;
